import axios from 'axios';
import { getDeviceParams } from '@/utils/device';
import {
  ApiError,
  ForbiddenApiError,
  UnautorisedApiError,
  UnexpectedApiError,
  UnprocessableApiError,
  ValidationApiError,
  RequestCancelled,
  NoResponseApiError,
  NotFoundApiError,
} from './apiErrors';

const baseURL = process.env.VUE_APP_BASE_URL;
export const apiInstance = axios.create({
  baseURL,
});

apiInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (!axios.isCancel(error)) {
      if (error.response && error.response.status) {
        switch (error.response.status) {
          case 403: {
            return Promise.reject(new ForbiddenApiError(error));
          }
          case 422: {
            return Promise.reject(new UnprocessableApiError(error));
          }
          case 404: {
            return Promise.reject(new NotFoundApiError(error));
          }
          case 409: {
            return Promise.reject(new ValidationApiError(error));
          }
          case 401: {
            return Promise.reject(new UnautorisedApiError(error));
          }
          case 500: {
            return Promise.reject(new UnexpectedApiError(error));
          }
          default: {
            return Promise.reject(new ApiError(error));
          }
        }
      } else {
        return Promise.reject(new NoResponseApiError(error));
      }
    } else {
      return Promise.reject(new RequestCancelled(error));
    }
  },
);

export const login365 = async (email, password) => {
  const result = await apiInstance.post('/v1/login/365', {
    email,
    password,
  }, { withCredentials: true, params: getDeviceParams() });
  return result.data;
};

export const loginQR = async (qr) => {
  const result = await apiInstance.post('/v1/login/QR', { qr }, {
    withCredentials: true,
    params: getDeviceParams(),
  });
  console.log('result', result.data);
  return result.data;
};

export const getActiveLogins = async () => {
  const result = await apiInstance.get('/v1/logins/active', {
    withCredentials: true,
  });
  return result.data;
};
